import { ClientBooking, ClientCampaignBooking } from '@round/api';
import uniq from 'lodash/uniq';

const isCampaignBooking = (booking: ClientBooking | ClientCampaignBooking): booking is ClientCampaignBooking =>
    typeof booking.influencer !== 'number';

export function calculateBookingsTotals(bookings: (ClientBooking | ClientCampaignBooking)[]) {
    const selectedPlatforms = uniq(bookings.map((booking) => booking.platform));

    const totalCreators = uniq(
        bookings.map((booking) => (isCampaignBooking(booking) ? booking.influencer.id : booking.influencer))
    ).length;

    const tiktokCreatorsCount = bookings.filter((booking) => booking.platform === 'TIKTOK').length;
    const instagramCreatorsCount = bookings.filter((booking) => booking.platform === 'INSTAGRAM').length;

    const notDeclinedBookings = bookings.filter((booking) => booking.status !== 'declined');

    const totalCost = notDeclinedBookings.reduce((agg, booking) => {
        const price = booking.price;
        return agg + price;
    }, 0);

    const liveBookings = bookings.filter((booking) => booking.status === 'posted');

    const totalLiveCost = liveBookings.reduce((agg, booking) => {
        const price = booking.price;
        return agg + price;
    }, 0);

    return { selectedPlatforms, totalCreators, tiktokCreatorsCount, instagramCreatorsCount, totalCost, totalLiveCost };
}
